import { workflowstart } from "../../requests/loader"
import Utils from "../../utils/Utils";
import { isSubscription } from '../utils/Utils'
import LinkSessionsTask from '../../requests/tasks/opt/LinkSessionsTask';
import RequestManager from '../../requests/RequestManager';

export const getwWorkflowstart = (url, groupId, offerId) => {
    const request = Utils.getRequest(url);
    return workflowstart({ groupId, offerId, linkworkflowstartParams: request.params });
}

export const parsePBI = (pbi) => {

    return {
        bannerpromo: pbi.bannerpromo,
        currency: pbi.currency,
        gateway: pbi.gateway,
        key: pbi.key,
        linkworkflowstart: pbi.linkworkflowstart,
        offerid: pbi.offerid,
        oneofferdesc: pbi.oneofferdesc,
        oneofferdesckey: pbi.oneofferdesckey,
        oneoffertype: pbi.oneoffertype,
        paymentmethod: pbi.paymentmethod,
        price: pbi.price,
        producttype: pbi.producttype,
        purchasechecked: pbi.purchasechecked,
        purchaseid: pbi.purchaseid,
        waspurchased: pbi.waspurchased,
        groupId: pbi.groupId,
        islive: pbi.islive ? pbi.islive : false,
        family: pbi.family,
        banner: pbi.banner,
        bonus: pbi.bonus,
        buy: pbi.buy,
        includes: pbi.includes, 
        frequency: pbi.frequency,
        style: pbi.style,
        periodicity: pbi.periodicity,
        isSubscription: isSubscription(pbi),
        isLive: pbi.isLive ? pbi.isLive: false,
        hideTextStep: !!pbi.hideTextStep,
        backButtonAlign: pbi.backButtonAlign,
        extraDisclaimer: pbi.extraDisclaimer,
    };
}

export const parseWorkFlowStart = (ws) => {

    const { workflow: { contentInfo, listBuyLinks } = {
        contentImageLarge: '',
        constentImageMedium: '',
        constentImageSmall: '',
        constentTitle: '',
    } } = ws;

    return {
        hasSavedPayway: ws.hasSavedPayway === '1' && ws.selectedPaymentMethod !== null,
        hasUserSusc: ws.hasUserSusc,
        list: ws.list || listBuyLinks,
        newWorkflow: ws.newWorkflow,
        selectedPaymentMethod: ws.selectedPaymentMethod,
        contentInfo
    }
}

export async function linkSessions(redirectUrl = null, type = 'POST', code = '', retries = 0, linkworkflowstartUrl = '') {
    try{
        const linkSessionsTask = new LinkSessionsTask(redirectUrl, type, code, retries, linkworkflowstartUrl);
        const result = await RequestManager.addRequest(linkSessionsTask);
        if(result.data) {
            result.status = '0';
        }
        return result;
    } catch (error) {
        console.error("Error in linkSessions:", error);
        throw error;
    }  
}


// WEBPACK FOOTER //
// ./src/payments/Checkout/utils.js